import Legal from "../Legal";

export default function CGV() {
  return (
    <Legal
      title="Conditions Générales de Vente"
      subtitle="Dernière mise à jour : Février 2026"
    >
      <h2>Article 1 — Objet</h2>
      <p>
        Les présentes Conditions Générales de Vente (CGV) régissent l'ensemble
        des transactions effectuées sur le site <strong>nordstellatech.fr</strong>{" "}
        entre Nord Stella Tech (ci-après "le Vendeur") et tout client
        (ci-après "l'Acheteur"). Toute commande implique l'acceptation pleine
        et entière des présentes CGV.
      </p>

      <h2>Article 2 — Identité du Vendeur</h2>
      <ul>
        <li><strong>Nord Stella Tech</strong> (nom commercial)</li>
        <li>Entrepreneur : Lacina DIOMANDE</li>
        <li>Statut : Auto-entrepreneur (Micro-entreprise)</li>
        <li>SIRET : 104 860 663 00012</li>
        <li>Adresse : 1 CHE d'Acces aux Abbesses, 93220 Gagny, FRANCE</li>
        <li>Email : nordstellatech@gmail.com</li>
      </ul>

      <h2>Article 3 — Produits</h2>
      <p>
        Les produits proposés sont décrits avec le plus grand soin. Les
        photographies sont communiquées à titre indicatif et n'engagent pas le
        Vendeur. Les produits sont disponibles dans la limite des stocks
        disponibles. En cas d'indisponibilité, l'Acheteur sera informé par email
        et remboursé dans un délai de 14 jours.
      </p>

      <h2>Article 4 — Prix et TVA</h2>
      <p>
        Les prix sont indiqués <strong>en dollars américains (USD)</strong>,
        toutes taxes comprises. Conformément à l'article{" "}
        <strong>293 B du Code Général des Impôts (CGI)</strong>, Nord Stella Tech
        bénéficie de la franchise en base de TVA :{" "}
        <strong>TVA non applicable, art. 293 B du CGI</strong>. Les frais de
        livraison sont indiqués séparément avant validation de la commande.
      </p>

      <h2>Article 5 — Commande</h2>
      <p>
        L'Acheteur passe commande via le site nordstellatech.fr. La commande n'est
        validée qu'après réception du paiement effectif. Un email de
        confirmation est envoyé à l'Acheteur.
      </p>

      <h2>Article 6 — Paiement</h2>
      <p>
        Le paiement est exigible immédiatement à la commande. Les paiements sont
        traités exclusivement via <strong>Stripe</strong>, prestataire de paiement
        sécurisé certifié PCI-DSS niveau 1. Cartes acceptées : Visa, Mastercard,
        American Express. Aucune donnée bancaire n'est stockée sur nos serveurs.
      </p>

      <h2>Article 7 — Livraison</h2>
      <p>
        Les produits sont expédiés depuis nos ateliers partenaires. Le
        traitement de la commande s'effectue sous{" "}
        <strong>24 à 48 heures ouvrées</strong> après validation du paiement.
        Le délai de livraison est de <strong>5 à 10 jours ouvrés</strong>{" "}
        à compter de l'expédition. Ces délais sont indicatifs et peuvent
        varier selon la destination et les contraintes logistiques.
      </p>
      <p>
        Un <strong>numéro de suivi</strong> est envoyé par email à l'Acheteur
        dès l'expédition.
      </p>
      <p>
        La livraison est gratuite dès <strong>$100</strong> d'achat. En dessous
        de ce montant, les frais d'expédition sont calculés au moment de la
        commande.
      </p>
      <p>
        En cas de retard supérieur à 30 jours après la date prévue, l'Acheteur
        peut demander la résolution de la vente et le remboursement intégral.
      </p>

      <h2>Article 8 — Droit de rétractation</h2>
      <p>
        Conformément aux articles L. 221-18 et suivants du Code de la
        consommation, l'Acheteur dispose d'un délai de{" "}
        <strong>14 jours calendaires</strong> à compter de la réception du
        produit pour exercer son droit de rétractation, sans avoir à justifier
        de motif ni à payer de pénalité.
      </p>
      <p>
        Pour exercer ce droit, l'Acheteur doit notifier sa décision par email à
        <a href="mailto:nordstellatech@gmail.com"> nordstellatech@gmail.com</a> et
        retourner le produit, dans son emballage d'origine et en état neuf,{" "}
        <strong>à l'adresse de l'entrepreneur</strong> :
      </p>
      <ul>
        <li>Nord Stella Tech — Lacina DIOMANDE</li>
        <li>1 CHE d'Acces aux Abbesses</li>
        <li>93220 Gagny, FRANCE</li>
      </ul>
      <p>
        Les frais de retour sont à la charge de l'Acheteur. Le remboursement
        intervient dans les 14 jours suivant la réception du produit retourné,
        sur le moyen de paiement initialement utilisé.
      </p>

      <h2>Article 9 — Garanties</h2>
      <p>
        L'Acheteur bénéficie de la <strong>garantie légale de conformité</strong>{" "}
        (articles L. 217-4 et suivants du Code de la consommation) pendant 2 ans
        à compter de la livraison, et de la <strong>garantie des vices
        cachés</strong> (articles 1641 et suivants du Code civil).
      </p>

      <h2>Article 10 — Données personnelles</h2>
      <p>
        Le traitement des données personnelles est décrit dans notre{" "}
        <a href="/legal/privacy">Politique de Confidentialité</a>, conforme au
        RGPD.
      </p>

      <h2>Article 11 — Litiges et droit applicable</h2>
      <p>
        Les présentes CGV sont soumises au droit français. En cas de litige,
        l'Acheteur peut recourir gratuitement à un médiateur de la consommation
        ou à la plateforme européenne de règlement des litiges en ligne
        accessible à l'adresse{" "}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer">
          ec.europa.eu/consumers/odr
        </a>
        . À défaut, les tribunaux français seront seuls compétents.
      </p>
    </Legal>
  );
}
